<div id="map-view-div">
  <div id="MAP_View_section">
    <div class="row map-view-section">
      <div class="col-sm-2">
        <a *ngIf="showBtn" (click)="pdf()" id="submit-pdf" download>Download</a>
        <a id="submit-pdf1" hidden download>Download</a>
        <a id="submit-pdf2" hidden download>Download</a>
        <span
          class="err-select-layers glyphicon glyphicon-warning-sign"
          style="display: none"
        ></span
        ><span class="err-select-layers" style="display: none">
          To download, select one or more layers above</span
        ><a id="download-map-view" download style="display: none">Download</a>
      </div>
      <div class="col-xs-12 col-sm-8">
        <div class="outer-col-map">
          <div class="map-preview-border">
            <div class="map-preview-col">
              <!-- <canvas
                style="width: 746px; height: 576px"
                width="746"
                height="576"
              ></canvas> -->
              <img *ngIf="show" class="img_canvas" [src]="url" />

              <!-- <embed  *ngIf="show" class="img_canvas "src="{{this.url}}" type="application/pdf"  > -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-loader></app-loader>
